/** Types */
export const GET_PAYERS = "GET_PAYERS";
export const GET_PAYERS_SUCCESS = "GET_PAYERS_SUCCESS";
export const GET_PAYER_SINGLE = "GET_PAYER_SINGLE";
export const GET_PAYER_SINGLE_SUCCESS = "GET_PAYER_SINGLE_SUCCESS";
export const ADD_PAYER = "ADD_PAYER";
export const EDIT_PAYER = "EDIT_PAYER";
export const DELETE_PAYER = "DELETE_PAYER";
export const CHANGE_STATUS_PAYER = 'CHANGE_STATUS_PAYER'

/** Connect Momentm to Payer */
export const GET_MOMENTM_PAYER = "GET_MOMENTM_PAYER";
export const GET_MOMENTM_PAYER_SUCCESS = "GET_MOMENTM_PAYER_SUCCESS";

export const CONNECT_MOMENTM_PAYER = "CONNECT_MOMENTM_PAYER";
export const EDIT_MOMENTM_PAYER = "EDIT_MOMENTM_PAYER";
export const EDIT_STATUS_MOMENTM_PAYER = "EDIT_STATUS_MOMENTM_PAYER";
/** End */

/** Appt Time Rules*/
export const EDIT_PAYER_TIME_RULES = "EDIT_PAYER_TIME_RULES";
export const PAYER_ENABLE_TIME = "PAYER_ENABLE_TIME";
/** End */

/** Payer Rates */
export const GET_PAYER_RATES = "GET_PAYER_RATES";
export const GET_PAYER_RATES_SUCCESS = "GET_PAYER_RATES_SUCCESS";
export const ADD_PAYER_RATE = "ADD_PAYER_RATE";
export const EDIT_PAYER_RATE = "EDIT_PAYER_RATE";
export const DELETE_PAYER_RATE = "DELETE_PAYER_RATE";
